import {useState,useEffect,useRef} from "react";
import {Link} from "react-router-dom";
import ImageWithBasePath from "../../../../../core/img";
import FeatherIcon from "feather-icons-react";
import ImageUploading from 'react-images-uploading';
import Select from "react-select";
import {Toaster} from 'react-hot-toast';
import {all_routes} from "../../../../router/all_routes";
// -- biz9 --
import {UrlQuery} from "biz9-react-utility";
import {Str,Status_Type} from "biz9-utility";
import {Page_Logic,Portal_Type,Portal_Url,Portal_Title,Sub_Value_Logic,Portal_Value_Type,Portal_Page,Portal_Remote_Page,Portal_Remote_Data,Portal_Remote_CMS,Portal_Table,Portal_Field,Portal_Remote_Image,Portal_Remote_User} from "biz9-portal-app";

import {Image_Type,Image_Table,Image_Field,Image_Format,Image_Service,Image_Url,Image_Logic} from "biz9-image";
import {User_Table,User_Logic,User_Field,User_Service,User_Url} from "biz9-user";
import {Message,Title} from "../../../../../constant";
import {Image,Style,Toast_Message,Storage,App} from "../../../../../project";
import {Data_Logic} from "biz9-data-app";
/* -- biz9 import end -- */
const Dashboard_Admin_User_Edit = () => {
    const query = UrlQuery();
    const alert_prop = useRef(null);
    const [val_id,setValId] = useState(query.get('id'));
    const [user,setUser] = useState(Data_Logic.get(Portal_Table.USER,0));
    const [val_username,setValUserName] = useState("");
    const [val_first_name,setValFirstName] = useState("");
    const [val_last_name,setValLastName] = useState("");
    const [val_email,setValEmail] = useState("");
    const [val_new_email,setValNewEmail] = useState("");
    const [val_confirm_email,setValConfirmEmail] = useState("");
    const [val_password,setValPassword] = useState("");
    const [val_new_password,setValNewPassword] = useState("");
    const [val_confirm_password,setValConfirmPassword] = useState("");
    const [val_country, setValCountry] = useState("");
    const [val_role, setValRole] = useState(null);
    const [sel_roles,setRoles] = useState(User_Logic.get_user_roles());
    const [val_state,setValState] = useState("");
    const [val_city,setValCity] = useState("");
    const [val_gender, setValGender] = useState("");
    const [hide_btn_image_post,setHideBtnImagePost] = useState(true);
    const [images,setImages] = useState([]);
    const [update_images,setUpdateImages] = useState([]);
    const [image_primary,setImagePrimary] = useState([]);
    const image_max_count = 1;
    useEffect(() => {
            Storage.post_dashboard_side_bar(Title.USER_SIDE_BAR_USER);
            if(!Str.check_is_null(val_id)){
            get_data();
            }
            },[val_id]);
    async function get_data() {
        /*
        const url = Remote.get_url(Config.APP_ID,Config.HOST,Portal_Url.DATA_GET);
        const option = {};
        const form_data = {option:option,table:Portal_Table.USER,id:val_id};
        const [biz_response,biz_data] = await Remote.post(url,form_data);
        bind_field(biz_data);
        */
    }
    const bind_field = (item) => {
        setUser(item);
        setValEmail(item.email);
        setValPassword(item.password);
        setValUserName(item.username);
        setValFirstName(item.first_name);
        setValLastName(item.last_name);
        setValCity(item.city);
        setValCountry(item.country);
        setValGender(item.gender);
        setValState(item.state);
        setValRole(sel_roles.find(option => option.value === item.role));
        if(item.image_filename){
            setImagePrimary([{image_filename:item.image_filename}]);
        }
    };
    const handle_submit = (event) => {
        event.preventDefault();
    };
    async function btn_post() {
        let valid_form = false;
        if(Str.check_is_null(val_username)){
            alert_prop.current.showValidation(Message.USERNAME_BAD);
        }
        if(!Str.check_is_null(val_new_password)){
            if(val_confirm_password != val_new_password){
                alert_prop.current.showValidation(Message.USER_PASSWORD_NEW_CONFIRM_BAD);
            }else if(!Str.check_is_true(Str.validate_password(val_new_password))){
                alert_prop.current.showValidation(Str.validate_password(val_new_password));
            }else{
                setValPassword(val_new_password);
                valid_form=true;
            }
        }
        else{
            if(!Str.check_is_null(val_new_password)){
                if(val_new_password != val_confirm_password){
                    alert_prop.current.showValidation(Message.PASSWORD_BAD);
                }
            }else{
                valid_form = true;
            }
        }
        if(valid_form){
            /*
               user.role = !Str.check_is_null(val_role) ? val_role.value : User_Role.USER;
               user.password = val_password;
               let [response,data] = await Portal_Remote_Data.post(App.get_url(Portal_Url.DATA_POST)Portal_Table.USER,query.get('id',user);
               alert_prop.current.showValidation(response.message);
               */
        }
    };
    const updateValFirstName = (event) => {
        setValFirstName(event.target.value);
    };
    const updateValLastName = (event) => {
        setValLastName(event.target.value);
    };
    const updateValEmail = (event) => {
        setValEmail(event.target.value);
    };
    const updateValNewEmail = (event) => {
        setValNewEmail(event.target.value);
    };
    const updateValConfirmEmail = (event) => {
        setValConfirmEmail(event.target.value);
    };
    const updateValPassword = (event) => {
        setValPassword(event.target.value);
    };
    const updateValNewPassword = (event) => {
        setValNewPassword(event.target.value);
    };
    const updateValConfirmPassword = (event) => {
        setValConfirmPassword(event.target.value);
    };
    const updateValCity = (event) => {
        setValCity(event.target.value);
    };
    const updateValCountry = (selectedOption) => {
        setValCountry(selectedOption);
    };
    const updateValRole = (selectedOption) => {
        setValRole(selectedOption);
        post_field(User_Field.ROLE,selectedOption.value,{});
    };
    const updateValState = (selectedOption) => {
        setValState(selectedOption);
    };
    const updateValGender = (event) => {
        setValGender(event.target.value);
    };
    const updateValUserName = (event) => {
        setValUserName(event.target.value);
    };
    async function onImagePrimaryChange(image_upload, addUpdateIndex){
        /*
        Toast_Message.loading(Message.SAVING);
        setHideBtnImagePost(true);
        let image = Data_Logic.get(Image_Table.IMAGE,0,{data:{base64:image_upload[0][Image_Field.BASE64],extension:Str.get_file_extension(image_upload[0][Image_Field.FILE][Image_Field.NAME])}});
        let [response,data] = await Portal_Remote_Image.post(App.get_url(Portal_Url.IMAGE_POST),[image]);
        if(response.status == Status_Type.SUCCESS){
            Toast_Message.success(response.message);
            setHideBtnImagePost(true);
            setImagePrimary([data[0]]);
        }else{
            Toast_Message.error(response.message);
            setHideBtnImagePost(false);
        }
        Toast_Message.dismiss();
        */
    };
    const onImagePrimaryDelete = () => {
        if (window.confirm(Message.CONFIRM)) {
            setImagePrimary([]);
            setHideBtnImagePost(false);
        }
    };
    async function set_image_list_delete(filename: any) {
        /*
           let image = images.find(item => item.image_filename == filename);
           setImages(images.filter(item => item.image_filename !== filename));
           setUpdateImages(update_images.filter(item => item.image_filename !== filename));
           if(!Obj.check_is_empty(image)&&!Str.check_is_null(image.id)){
           let [response,data] = await App_User_Data_Service.post(App.get_url(Portal_Url.DATA_POST)Portal_Url.DATA_DELETE,{table:Image_Table.IMAGE,id:image.id});
           }
           */
    };
    //9_post_field
    async function post_field(field,value,option){
        /*
        if(!value){
            value = '';
        }
        // -- role --
        if(field == User_Field.ROLE){
            user[field] = value;
            let [response,data] = await Portal_Remote_User.post(App.get_url(Portal_Url.USER_POST),user);
            if(response.status == Status_Type.SUCCESS){
                Toast_Message.success(response.message);
            }else{
                Toast_Message.success(response.message);
            }
        }
        // -- password --
        if(field == User_Field.PASSWORD){
            if(val_confirm_password != value){
                Toast_Message.error(Message.USER_PASSWORD_NEW_CONFIRM_BAD);
            }else if(!Str.check_is_true(Str.validate_password(value))){
                Toast_Message.error(Str.validate_password(value));
            }else{
                user[field] = value;
                let [response,data] = await Portal_Remote_User.post(App.get_url(Portal_Url.USER_POST),user);
                if(response.status == Status_Type.SUCCESS){
                    Toast_Message.success(response.message);
                    setValPassword(value);
                }else{
                    Toast_Message.success(response.message);
                }
            }
        }
        // -- email --
        if(field == User_Field.EMAIL){
            if(val_confirm_email != value){
                Toast_Message.error(Message.USER_EMAIL_NEW_CONFIRM_BAD);
            }else if(!Str.check_is_true(Str.validate_email(value))){
                Toast_Message.error(Str.validate_password(value));
            }else{
                user[field] = value;
                let [response,data] = await Portal_Remote_User.post(App.get_url(Portal_Url.USER_POST),user);
                if(response.status == Status_Type.SUCCESS){
                    Toast_Message.success(response.message);
                }else{
                    Toast_Message.success(response.message);
                }
            }
        }
        */
    };
    return (
            <>
            <Toaster />
            {/* Page Content */}
            <div className="page-wrapper">
            <div className="page-content content bg-light">
            <div className="row justify-content-center">
            <div className="col-lg-10">
            <div className="main-title mb-4">
            <h4>Settings B</h4>
            </div>
            <div className="settings-info bg-white rounded-2">
            <div className="tab-content">
            {/* Profile Settings */}
            <div
            className="tab-pane fade show active"
            id="Personal_Information"
            role="tabpanel"
            >
            <Link to={all_routes.dashboard_admin_user_detail+"?id="+query.get('id')}  className="nav-link" >
            {"<- Back to Profile"}
            </Link>
                <br/>
                <div className="settings-card">
                <div className="settings-card-head bg-light">
                <h4>Personal Information</h4>
                </div>
                <form onSubmit={handle_submit}>

                <div className="settings-card-body">
                <div className="img-upload-head">
                <div className="img-formate">
                <div className="upload-remove-btns">

                <div className="form-wrap">
                <ImageUploading
                value={image_primary}
            onChange={onImagePrimaryChange}
            maxNumber={image_max_count}
            dataURLKey={Image_Field.BASE64}>
            {({
                    imageList,
                    onImageUpload,
                    onImageRemoveAll,
                    onImageUpdate,
                    isDragging,
                    dragProps,
                    }) => (
                        <div className="upload__image-wrapper">
                        <button hidden={hide_btn_image_post} className="btn btn-secondary mb-2"
                        style={isDragging ? { color: 'red' } : undefined} onClick={() =>  onImageUpload()}
                        {...dragProps} >
                        Image
                        </button>
                        &nbsp;
                        {imageList.map((image, index) => (
                                    <div key={index} className="image-item">
                                    <img  src={Image.get_url(image.image_filename,Image_Format.SQUARE_THUMB)} alt=""  height="200" width="200" />
                                    <div className="image-item__btn-wrapper">
                                    <Link hidden={hide_btn_image_post} onClick={() => onImagePrimaryDelete() } to="#" className="mb-2" >
                                    <FeatherIcon  icon="trash-2" />
                                    </Link>
                                    </div>
                                    </div>
                                    ))}
                        </div>
                        )}
            </ImageUploading>
                </div>
                </div>
                </div>
                </div>
                <div className="row">
                <div className="col-md-4">
                <div className="form-wrap">
                <label className="form-label">
                {" "}
            UserName{" "}
            <span className="text-primary">*</span>
                </label>
                <input disabled={true} value={val_username} type="text" className="form-control" />
                </div>
                </div>
                <div className="col-md-4">
                <div className="form-wrap gig-option">
                <label className="mb-1 fw-medium text-dark d-block mb-2">
                {" "}
            Gender <span className="text-primary">*</span>
                </label>
                <input disabled={true} value={val_gender} type="text" className="form-control" />
                </div>
                </div>
                </div>

                <div className="row">

                <div className="col-md-4">
                <div className="form-wrap">
                <label className="form-label">
                {" "}
            First Name{" "}
            </label>
                <input disabled={true} value={val_first_name} type="text" className="form-control" />
                </div>
                </div>

                <div className="col-md-4">
                <div className="form-wrap">
                <label className="form-label">
                {" "}
            Last Name{" "}
            </label>
                <input disabled={true} value={val_last_name} type="text" className="form-control" />
                </div>
                </div>
                <div className="col-md-4">
                <div className="form-wrap">
                <label className="form-label">
                {" "}
            Email <span className="text-primary">*</span>
                </label>
                <input disabled={true} value={val_email} type="email" className="form-control" />
                </div>
                </div>

                <div className="col-md-4">
                <div className="form-wrap">
                <label className="form-label mb-1 fw-medium text-dark">
                City
                </label>
                <input disabled={true} value={val_city}  type="text" className="form-control" />
                </div>
                </div>

                <div className="col-md-4">
                <div className="form-wrap">
                <label className="form-label mb-1 fw-medium text-dark">
                Country<span className="text-primary">*</span>
                </label>
                <input disabled={true} value={val_country} type="text" className="form-control" />
                </div>
                </div>
                <div className="col-md-4">
                <div className="form-wrap">
                <label className="form-label mb-1 fw-medium text-dark">
                State<span className="text-primary">*</span>
                </label>
                <input disabled={true} value={val_state}  type="text" className="form-control" />
                </div>
                </div>

                </div>
                </div>
                </form>
                </div>

                <div className="settings-card">
                <div className="settings-card-head bg-light">
                <h4>Role</h4>
                </div>
                <form>
                <div className="settings-card-body">
                <div className="row">
                <div className="col-md-4">
                <div className="form-wrap mb-lg-0 mb-md-0">
                <label className="form-label">
                {" "}
            Role{" "}
            <span className="text-primary">*</span>
                </label>
                <Select
                classNamePrefix="react-select"
                className="select"
                styles={Style.customStyles}
            options={sel_roles}
            value={val_role}
            onChange={updateValRole}/>
                </div>
                </div>


                </div>
                </div>
                </form>
                </div>


                <div className="settings-card">
                <div className="settings-card-head bg-light">
                <h4>Settings</h4>
                </div>
                <form>
                <div className="settings-card-body">
                <div className="row">

                <div className="col-md-4">
                <div className="form-wrap mb-lg-0 mb-md-0">
                <label className="form-label">
                {" "}
            New Email{" "}
            <span className="text-primary">*</span>
                </label>
                <input type="text" onChange={updateValNewEmail} value={val_new_email} className="form-control" />
                </div>
                </div>

                <div className="col-md-4">
                <div className="form-wrap mb-0">
                <label className="form-label">
                {" "}
            Confirm Email{" "}
            <span className="text-primary">*</span>
                </label>
                <input type="text" onChange={updateValConfirmEmail} value={val_confirm_email} className="form-control" onBlur={() => post_field(User_Field.EMAIL,val_new_email,{})} />
                </div>
                </div>
                </div>
                </div>
                </form>
                </div>


                <div className="settings-card">
                <div className="settings-card-head bg-light">
                <h4>Change Password</h4>
                </div>
                <form>
                <div className="settings-card-body">
                <div className="row">
                <div className="col-md-4">
                <div className="form-wrap mb-lg-0 mb-md-0">
                <label className="form-label">
                {" "}
            Current Password{" "}
            </label>
                <input disabled={true} value={val_password} type="password" className="form-control" />
                </div>
                </div>
                <div className="col-md-4">
                <div className="form-wrap mb-lg-0 mb-md-0">
                <label className="form-label">
                {" "}
            New Password{" "}
            </label>
                <input type="text" onChange={updateValNewPassword} value={val_new_password} className="form-control" />
                </div>
                </div>


                <div className="col-md-4">
                <div className="form-wrap mb-0">
                <label className="form-label">
                {" "}
            Confirm Password{" "}
            </label>
                <input type="text" onChange={updateValConfirmPassword} value={val_confirm_password} className="form-control" onBlur={() => post_field(User_Field.PASSWORD,val_confirm_password,{})} />
                </div>
                </div>
                </div>
                </div>
                </form>
                </div>

                </div>
                {/* /Profile Settings */}
            </div>
            {/* /Page Content */}
            </div>
                <div className="settings-card-footer">

                </div>
                </div>
                </div>
                </div>
                {/* /Page Content */}
            {/* Mouse Cursor */}
            <div className="mouse-cursor cursor-outer" />
                <div className="mouse-cursor cursor-inner" />
                {/* /Mouse Cursor */}
            {/* Top Scroll */}
            <div className="back-to-top">
                </div>

                {/* /Top Scroll */}
            </div>
                </>
                );
};

export default Dashboard_Admin_User_Edit;
